const a = (e) => {
  var t;
  return {
    "x-scalar-reference-config": {
      title: e.title,
      slug: e.slug,
      features: {
        // Feature toggles for UI elements and behaviors
        showModels: !e.hideModels,
        expandAllTagSections: e.defaultOpenAllTags,
        persistAuthenticationState: e.persistAuth,
        showDarkModeToggle: !e.hideDarkModeToggle,
        showDownload: !e.hideDownloadButton,
        showSearch: !e.hideSearch,
        showSidebar: e.showSidebar,
        showTestRequestButton: !e.hideTestRequestButton
      },
      appearance: {
        // Appearance-related configuration
        css: e.customCss,
        favicon: e.favicon,
        forceColorMode: e.forceDarkModeState,
        initialColorMode: e.darkMode ? "dark" : void 0,
        layout: e.layout,
        loadDefaultFonts: e.withDefaultFonts,
        theme: e.theme
      },
      routing: {
        // Routing configuration
        basePath: (t = e.pathRouting) == null ? void 0 : t.basePath
      },
      settings: {
        // Miscellaneous settings
        proxyUrl: e.proxyUrl,
        searchKey: e.searchHotKey,
        baseServerUrl: e.baseServerURL,
        servers: e.servers
      },
      meta: e.metaData,
      // In memory configuration
      tagSort: e.tagsSorter,
      operationsSorter: e.operationsSorter,
      generateHeadingSlug: e.generateHeadingSlug,
      generateModelSlug: e.generateModelSlug,
      generateOperationSlug: e.generateOperationSlug,
      generateTagSlug: e.generateTagSlug,
      generateWebhookSlug: e.generateWebhookSlug
    }
  };
};
export {
  a as mapConfiguration
};
